// Main navigation - siteHeader

/* Sticky:
 * To make the header stay put at the top of the site when scrolling. */
export const makeHeaderNavigationSticky = () => {
  var menu = document.getElementById("siteHeader");
  menu.classList.add("js-sticky");
};

/* END Sticky */
/* Hover-menu:
 * Makes the menu options expand the submenu with the mouse hovering over the link-element.
 */

const toogleSubMenuHover = ({ target }) => {
  let expanded = target.getAttribute("aria-expanded") === "true" || false;
  target.setAttribute("aria-expanded", !expanded);
  let submenu = target.nextElementSibling;
  submenu.setAttribute("aria-expanded", !expanded);
  submenu.classList.toggle("submenu--expanded");
};

export const eventListenerAddExpandMenu = () => {
  var expandMenuElements = document.getElementsByClassName(
    "main-navigation__toggle-submenu"
  );
  Array.from(expandMenuElements).forEach((element) => {
    element.addEventListener("click", (e) => toogleSubMenuHover(e));
  });
};

/* END Hover-menu */
/* Clicky-menu:
 * Makes the menu options to expand the submenu with a click of a button-element.
 */

let currentMenuItem;


const closePrevSubMenuBtn = ({ target }) => {
  if (currentMenuItem && target !== currentMenuItem) {
    toggleSubMenuClickyBtn(currentMenuItem);
  }

  toggleSubMenuClickyBtn(target);
};

const closeOpenSubMenu = ({ target }) => {
  if (currentMenuItem && !target.closest("#siteHeader")) {
    toggleSubMenuClickyBtn(currentMenuItem);
  }
};

const closeSubMenuOnEscKey = ({ keyCode, target }) => {
  if (27 === keyCode) {
    // we're in a submenu item
    if (
      null !==
      target.closest('div[aria-expanded="true"]' || 'ul[aria-expanded="true"]')
    ) {
      currentMenuItem.focus();
      toggleSubMenuClickyBtn(currentMenuItem);

      // we're on a parent item
    } else if ("true" === target.getAttribute("aria-expanded")) {
      toggleSubMenuClickyBtn(currentMenuItem);
    }
  }
};

const toggleSubMenuClickyBtn = (button) => {
  let submenu = button.nextElementSibling;
  let bodyClass = document.querySelector("body");

  if ("true" === button.getAttribute("aria-expanded")) {
    button.setAttribute("aria-expanded", false);
    submenu.classList.toggle("submenu--expanded");
    submenu.setAttribute("aria-expanded", false);
    currentMenuItem = false;
  } else {
    button.setAttribute("aria-expanded", true);
    submenu.classList.toggle("submenu--expanded");
    submenu.setAttribute("aria-expanded", true);
    currentMenuItem = button;
  }
};

export const eventListenerClickyMenuBtn = () => {
  var clickyMenuBtnsArray = document.getElementsByClassName(
    "main-navigation__button"
  );
  Array.from(clickyMenuBtnsArray).forEach((element) => {
    element.addEventListener("click", (e) => closePrevSubMenuBtn(e));
  });

  var headerMenu = document.getElementById("mainNavigation");
  headerMenu.addEventListener("keyup", (e) => closeSubMenuOnEscKey(e));
  document.addEventListener("click", (e) => closeOpenSubMenu(e));

  var clickySubMenuCloseBtnsArray = document.getElementsByClassName(
    "main-navigation__close-submenu"
  );
  Array.from(clickySubMenuCloseBtnsArray).forEach((element) => {
    element.addEventListener("click", (e) => closePrevSubMenuBtn(e));
  });
};

export const eventListenerNavButton = () => {
  var navButton = document.querySelector("#mainNavigation > button");
  navButton.addEventListener("click", function () {
    let expanded = this.getAttribute("aria-expanded") === "true" || false;
    this.setAttribute("aria-expanded", !expanded);
    let bodyClass = document.querySelector("body");
    bodyClass.classList.toggle("body__main-navigation--expanded");
  });
};

/* END Clicky-menu */
